import Component from '@glimmer/component';
import FunctionalUtils from 'mewe/shared/functional-utils';

export default class Colors extends Component {
  colorPalettes = [
    {
      name: 'Grey Palette',
      colors: [
        { name: '$grey00', value: '#FAFAFB', hasBorder: true },
        { name: '$grey10', value: '#F8F8F9', hasBorder: true },
        { name: '$grey20', value: '#F1F1F3', hasBorder: true },
        { name: '$grey30', value: '#E1E1E5', hasBorder: false },
        { name: '$grey40', value: '#C2C2C6', hasBorder: false },
        { name: '$grey50', value: '#AFAFB4', hasBorder: false },
        { name: '$grey60', value: '#767681', hasBorder: false },
        { name: '$grey70', value: '#3F3F46', hasBorder: false },
        { name: '$grey80', value: '#2C2C33', hasBorder: false },
        { name: '$grey90', value: '#151518', hasBorder: false },
        { name: '$grey100', value: '#0A0A0C', hasBorder: false }
      ]
    },
    {
      name: 'Green Palette (Primary)',
      colors: [
        { name: '$green10', value: '#D8FFEE', hasBorder: true },
        { name: '$green20', value: '#83FFC9', hasBorder: false },
        { name: '$green30', value: '#6DF5BA', hasBorder: false },
        { name: '$green40', value: '#5BE6AA', hasBorder: false },
        { name: '$green50', value: '#4DD39A', hasBorder: false },
        { name: '$green60', value: '#44BB89', hasBorder: false },
        { name: '$green70', value: '#349E76', hasBorder: false },
        { name: '$green80', value: '#267F62', hasBorder: false },
        { name: '$green90', value: '#1A5F4B', hasBorder: false },
        { name: '$green100', value: '#0F3D32', hasBorder: false }
      ]
    },
    {
      name: 'Violet Palette (Secondary)',
      colors: [
        { name: '$violet10', value: '#F4EFFE', hasBorder: true },
        { name: '$violet20', value: '#E7D9FB', hasBorder: false },
        { name: '$violet30', value: '#D1B6F7', hasBorder: false },
        { name: '$violet40', value: '#BF8EEE', hasBorder: false },
        { name: '$violet50', value: '#A86EF0', hasBorder: false },
        { name: '$violet60', value: '#8438E9', hasBorder: false },
        { name: '$violet70', value: '#6825C9', hasBorder: false },
        { name: '$violet80', value: '#4C0E9B', hasBorder: false },
        { name: '$violet90', value: '#2E0A59', hasBorder: false },
        { name: '$violet100', value: '#1A0529', hasBorder: false }
      ]
    },
    {
      name: 'Yellow Palette (Tertiary)',
      colors: [
        { name: '$yellow10', value: '#fBEED5', hasBorder: true },
        { name: '$yellow20', value: '#F3D485', hasBorder: false },
        { name: '$yellow30', value: '#EDC272', hasBorder: false },
        { name: '$yellow40', value: '#E6B05F', hasBorder: false },
        { name: '$yellow50', value: '#DFA04C', hasBorder: false },
        { name: '$yellow60', value: '#D68E37', hasBorder: false },
        { name: '$yellow70', value: '#C97A20', hasBorder: false },
        { name: '$yellow80', value: '#B9640D', hasBorder: false },
        { name: '$yellow90', value: '#99500A', hasBorder: false },
        { name: '$yellow100', value: '#7B3D07', hasBorder: false }
      ]
    },
    {
      name: 'Blue Palette (Accent)',
      colors: [
        { name: '$blue10', value: '#E6F4FF', hasBorder: true },
        { name: '$blue20', value: '#B3E0FF', hasBorder: false },
        { name: '$blue30', value: '#80CCFF', hasBorder: false },
        { name: '$blue40', value: '#4DB8FF', hasBorder: false },
        { name: '$blue50', value: '#1AA3FF', hasBorder: false },
        { name: '$blue60', value: '#008AE6', hasBorder: false },
        { name: '$blue70', value: '#0070BF', hasBorder: false },
        { name: '$blue80', value: '#005699', hasBorder: false },
        { name: '$blue90', value: '#003D73', hasBorder: false },
        { name: '$blue100', value: '#00264D', hasBorder: false }
      ]
    },
    {
      name: 'System Colors',
      colors: [
        { name: '$blue10', value: '#E6F4FF', hasBorder: true, label: "Information"},
        { name: '$blue60', value: '#008AE6', hasBorder: false },
        { name: '$green10', value: '#D8FFEE', hasBorder: true, label: "Success" },
        { name: '$green60', value: '#44BB89', hasBorder: false },
        { name: '$yellow10', value: '#FBEED5', hasBorder: true, label: "Warning" },
        { name: '$yellow50', value: '#DFA04C', hasBorder: false },
        { name: '$coral10', value: '#FFE6EC', hasBorder: true, label: "Error" },
        { name: '$coral60', value: '#E04C6A', hasBorder: false }
      ]
    }
  ];

  copyColor(color) {
    navigator.clipboard.writeText(color);
    FunctionalUtils.info('Copied to clipboard');
  }
}
